import { NgClass } from "@angular/common";
import { Component, DestroyRef, inject, OnDestroy, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatIcon } from "@angular/material/icon";
import { AppService } from "src/app-legacy/core/services/app.service";
import { AuthService } from "src/app-legacy/core/services/auth.service";
import { SUPPORT_ACCESS_TOKEN_KEY, SUPPORT_TOKEN_EXPIRY_TIME_KEY } from "src/app/core/constants/storage-keys";

@Component({
	selector: "app-customer-support-mode-alert",
	imports: [MatIcon, NgClass],
	templateUrl: "./customer-support-mode-alert.component.html",
})
export class CustomerSupportModeAlertComponent implements OnInit, OnDestroy {
	private appService = inject(AppService);
	private authService = inject(AuthService);
	private destroyRef = inject(DestroyRef);

	currentSchool = this.appService.currentSchool.name;

	supportMode = !!localStorage.getItem(SUPPORT_ACCESS_TOKEN_KEY);
	supportDeadline = Number(localStorage.getItem(SUPPORT_TOKEN_EXPIRY_TIME_KEY));

	hoursToDeadline?: number;
	minutesToDeadline?: number;
	secondsToDeadline?: number;

	interval: any;

	ngOnInit(): void {
		if (this.supportMode && this.supportDeadline) {
			this.calculateRemainingTime();
		}
	}

	ngOnDestroy(): void {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	calculateRemainingTime(): void {
		this.interval = setInterval(() => {
			const remainingSeconds = (this.supportDeadline - Date.now()) / 1000;
			this.hoursToDeadline = Math.floor(remainingSeconds / 3600);
			this.minutesToDeadline = Math.floor((remainingSeconds / 60) % 60);
			this.secondsToDeadline = Math.floor(remainingSeconds % 60);

			if (remainingSeconds < 1) {
				clearInterval(this.interval);
				this.endSupportSession();
			}
		}, 1000);
	}

	endSupportSession(): void {
		// Redirect user back to internal views
		const internalViewSchoolId = 155539;
		this.authService
			.switchToSchool(internalViewSchoolId)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: () => {
					location.reload(); // Reload to clear any cached data
				},
				error: (error) => {
					this.appService.openErrorSnackBar(error);
				},
			});
	}
}
